import { useState } from "react";

export const BeforeAfterSlider = ({ before, after, id }) => {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative aspect-[4/3] select-none overflow-hidden bg-black" data-testid={`ba-slider-${id}`}>
      <img src={after.src} alt={after.alt || "Después de la reparación"} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before.src} alt={before.alt || "Antes de la reparación"} loading="lazy" className="h-full w-full object-cover" />
      </div>
      <span className="absolute left-3 top-3 rounded-sm bg-black/70 px-2 py-1 text-xs font-bold uppercase text-white">Antes</span>
      <span className="absolute right-3 top-3 rounded-sm bg-gold px-2 py-1 text-xs font-bold uppercase text-black">Después</span>
      <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }}>
        <span className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white bg-black/60 px-2 py-1 text-xs text-white">⇆</span>
      </div>
      <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))} aria-label="Comparar antes y después"
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0" data-testid={`ba-range-${id}`} />
    </div>
  );
};
